<template>
  <div class="myask">
    <van-nav-bar
    v-if="source==1"
    title="我的问答"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-tabs v-model="active" title-active-color="#F6AB00" color="#F6AB00" @click="onClick" :style="{'margin-top':source==1?'45px':'0'}" sticky>
      <van-tab title="提问">
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
        >
        <div class="list-box" v-for="item in qlist" :key="'qlist_' + item.id">
          <div class="listitle ellipsis-2">
            <img class="quespic" :src="img.question">
            {{ item.question }}
          </div>
          <div class="f-14">
            {{ item.content }}
          </div>
          <div class="pic-box" v-if="item.image">
            <img class="pic_thumb" fit="cover" :src="item.image">
          </div>
          <van-row type="flex" justify="space-between">
            <van-col span="14">
              <span class="sourtime">暂无回答</span>
            </van-col>
            <van-col class="bintright" span="10" :data-code="item.id" @click="delQuestion">
              <span class="sourtime">删除</span>
            </van-col>
          </van-row>
        </div>
      </van-list>
    </van-tab>
    <van-tab title="回答">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
      >
      <div class="list-box" v-for="item in alist" :key="'alist_' + item.answer.id">
        <div class="listitle ellipsis-2">
          {{ item.question }}
        </div>
        <van-row gutter="15" v-if="item.answer.content.img">
          <van-col span="8">
            <img class="picone" :src="item.answer.content.img">
          </van-col>
          <van-col span="16" class="f-14 ellipsis-4">
            <img class="quespic" :src="img.answer">
            {{ item.answer.content.text }}
          </van-col>
        </van-row>
        <div class="f-14 ellipsis-4" v-else>
          <img class="quespic" :src="img.answer">
          {{ item.answer.content.text }}
        </div>
        <div class="c-blue f-14 text-r">查看答案</div>
        <van-row type="flex" justify="space-between">
          <van-col span="14">
            <span class="sourtime">{{item.answer.answer_time}}</span>
          </van-col>
          <van-col class="bintright" span="10">
            <span class="">
              <img class="binpic" :src="img.  comment">
              <span class="sourtime">{{item.answer.reply_num}}</span>
            </span>
            <span class="binbox">
              <img class="binpic" :src="img.parise">
              <span class="sourtime">{{item.answer.praise_num}}</span>
            </span>
          </van-col>
        </van-row>
      </div>
    </van-list>
  </van-tab>
  <van-tab title="草稿">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    :immediate-check="false"
    @load="onLoad"
    >
    <div class="list-box" v-for="item in dlist" :key="'dlist_' + item.id">
      <div v-if="item.type.id==1">
        <van-row>
          <van-col span="2">
            <img class="quespic" :src="img.question">
          </van-col>
          <van-col span="22">
            <div class="listitle ellipsis-2">
              {{ item.question }}
            </div>
          </van-col>
        </van-row>
        <div class="f-14">
          {{ item.content }}
        </div>
        <div class="pic-box" v-if="item.image">
          <img class="pic_thumb" fit="cover" :src="item.image">
        </div>
        <van-row type="flex" justify="space-between">
          <van-col span="14">
            <span class="sourtime">保存于  {{item.created_at}}</span>
          </van-col>
          <van-col class="bintright" span="10" :data-code="item.id" @click="delDefault">
            <span class="sourtime">删除</span>
          </van-col>
        </van-row>
      </div>
      <div v-else-if="item.type.id==3">
        <div class="listitle ellipsis-2">
          {{ item.ques.question }}
        </div>
        <van-row gutter="15" v-if="item.content[0].img.length>0">
          <van-col span="8">
            <img class="picone" :src="item.content[0].img">
          </van-col>
          <van-col span="16" class="f-14 ellipsis-4">
            <img class="quespic" :src="img.answer">
            {{ item.content[0].text }}
          </van-col>
        </van-row>
        <div class="f-14 ellipsis-4" v-else>
          <img class="quespic" :src="img.answer">
          {{ item.content[0].text }}
        </div>
        <div class="c-blue f-14 text-r">查看答案</div>
        <van-row type="flex" justify="space-between">
          <van-col span="14">
            <span class="sourtime">保存于  {{item.created_at}}</span>
          </van-col>
          <van-col class="bintright" span="10" :data-code="item.id" @click="delDefault">
            <span class="sourtime">删除</span>
          </van-col>
        </van-row>
      </div>
      
    </div>
  </van-list>
</van-tab>
</van-tabs>
</div>
</template>
<script>
  import list from '../../../api/member/myask';
  import { mapState } from 'vuex';
  import { Tab, Tabs, List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon,NavBar} from 'vant';
  
  export default {
    data(){
      return{
        active: 0,
        qlist: [],
        alist:[],
        dlist:[],
        page:1,
        channel_id:'',
        user_id:'',
        loading: false,
        finished: false,
        num:10,
        img: {
         parise: require('../../../assets/img/parise.png'),
         parise_have: require('../../../assets/img/parise_have.png'),
         comment: require('../../../assets/img/comment.png'),
         avatar: require('../../../assets/img/default.jpg'),
         question: require('../../../assets/img/question.png'),
         answer: require('../../../assets/img/answers.png'),
       }
     }
   },
   computed: {
    ...mapState({
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    if(!Lockr.get('token')) {

      if(this.source == 3) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            this.$appService.needLogin()
          }
        })
      }

      this.$toast('请先登录')
      return false
    }
    if(this.source == 3||this.source == 7) {
      this.$appService.isShowReturn({state: true})
    }

    let params={
      channel_id:"",
      page:this.page,
    }
    this.getAsk(params)
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    onClick(name){
      if(name==0){
        this.qlist=[]
        this.page=1
        let params={
         channel_id:"",
         page:1
       }
       this.getAsk(params)
     }else if(name==1){
      this.alist=[]
      this.page=1
      let params={
        channel_id:"",
        page:1
      }
      this.getAnswer(params)
    }else{
      this.dlist=[]
      this.page=1
      let params={
        channel_id:"",
        page:1
      }
      this.getDraft(params)
    }
  },
  getAsk(params){
    list.getAsk(params).then(res => {
      if(res.data.state == 1) {
        let qlist=this.qlist
        let newlist=res.data.data.data
        if(qlist.length==0){
          this.qlist = res.data.data.data
        }else{
          this.num=newlist.length
          this.qlist = this.qlist.concat(newlist)
        }
      }
    })
  },
  getAnswer(params){
    list.getAnswer(params).then(res => {
      if(res.data.state == 1) {
        let alist=this.alist
        let newlist=res.data.data.data
        if(alist.length==0){
          this.alist = res.data.data.data
        }else{
          this.num=newlist.length
          this.alist = this.alist.concat(newlist)
        }
      }
    })
  },
  getDraft(params){
    list.getDraft(params).then(res => {
      if(res.data.state == 1) {
        let dlist=this.dlist
        let newlist=res.data.data.data
        if(dlist.length==0){
          this.dlist = res.data.data.data
        }else{
          this.num=newlist.length
          this.dlist = this.dlist.concat(newlist)
        }
      }
    })
  },
  delQuestion(e){
    let id=e.currentTarget.dataset.code
    this.$dialog.confirm({
      message: '确定要删除吗？'
    }).then(() => {
     let list=this.qlist
     for (var i=0;i<list.length;i++) {
      if(list[i].id==id){
       list.splice(i, 1)
     }
   }
   this.qlist=list
   this.$toast.success('删除成功');
 }).catch(() => {
 });
},
delDefault(e){
  let id=e.currentTarget.dataset.code
  this.$dialog.confirm({
    message: '确定要删除吗？'
  }).then(() => {
    list.delDefault(id).then(res => {
      if(res.data.state == 1) {
        let list=this.dlist
        for (var i=0;i<list.length;i++) {
          if(list[i].id==id){
           list.splice(i, 1)
         }
       }
       this.dlist=list
       this.$toast.success('删除成功');
     }
   })
  }).catch(() => {
  });
},
onClickLeft(){
  this.$router.go(-1)
},
onLoad() {
  setTimeout(() => {
    let num=this.num
    if (num <10) {
      this.finished = true
      this.loading = false
    }else{
      this.page=this.page+1
      let params={
        channel_id:"",
        page:this.page
      }
      if(this.active==0){
        this.getAsk(params)
      }else if(this.active==1){
        this.getAnswer(params)
      }else{
        this.getDraft(params)
      }
      this.loading = false
    }
  }, 500);
},
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [List.name]: List,
  [Button.name]: Button,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [Tag.name]: Tag,
  [Image.name]:Image,
  [Icon.name]:Icon,
  [NavBar.name]:NavBar
}
}
</script>

<style lang="scss">
.myask{
  // .van-nav-bar__left {
  //   left: 10px;
  // }
  .list-box{
    padding: 15px;
    border-bottom: 1px solid #f8f8f8;
    a {
      padding: 0;
      color: #3A3A3A;
    }
    .picone{
      width:100%;
      height:105px;
      border-radius:5px;
    }
    .listitle{
      font-size: 16px;
      font-weight:bold;
      line-height: 1.8;
      letter-spacing: 1.4px;
    }
    .sourtime{
      font-size:14px;
      color:rgba(154,154,154,1);
    }
    .bintright{
      text-align:right;
      .binbox{
        margin-left:20px;
      }
      .binpic{
        width:15px;
        height:14px;
        margin-right:8px;
      }
    }
    .pic-box {
      padding: 10px 0 10px 0 !important;
      height: 210px !important;
      .pic_thumb{
        border-radius: 5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .quespic{
      width: 22px;
      height: 22px;
      vertical-align: middle;
    }
  }
}
</style>
